import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import EmployeeMemoPanel, { MEMO_CHANNEL } from './EmployeeMemoPanel';

// 따로 띄운 메모 창. 대장 화면에서 다른 직원의 메모 단추를 누르면 이 창의 내용이 그 직원으로 바뀌고,
// 여기서 저장하면 대장 화면의 메모 단추에도 바로 반영된다.
function MemoWindow() {
  const [params] = useSearchParams();
  const channel = useRef(null);
  const [state, setState] = useState(() => ({
    companyId: params.get('company'),
    companyName: params.get('companyName') || '',
    target: {
      rowId: params.get('row'),
      employeeId: params.get('employee') || null,
      name: params.get('name') || '',
      idNumber: params.get('idNumber') || '',
    },
  }));

  useEffect(() => {
    if (typeof BroadcastChannel === 'undefined') return undefined;
    const ch = new BroadcastChannel(MEMO_CHANNEL);
    channel.current = ch;
    ch.onmessage = (e) => {
      const msg = e.data || {};
      if (msg.type === 'open') setState({ companyId: msg.companyId, companyName: msg.companyName || '', target: msg.target });
    };
    return () => { ch.close(); channel.current = null; };
  }, []);

  useEffect(() => { document.title = `메모 · ${state.target.name || ''}`; }, [state.target.name]);

  const { companyId } = state;
  const onSaved = useCallback((memo) => {
    if (channel.current) channel.current.postMessage({ type: 'saved', companyId, memo });
    setState((s) => ({ ...s, target: { ...s.target, employeeId: memo.employee_id } }));
  }, [companyId]);

  if (!state.companyId || !state.target.rowId) return <p style={{ padding: 16 }}>대장 화면에서 직원의 메모 단추를 눌러 주세요.</p>;
  return (
    <EmployeeMemoPanel
      key={state.target.rowId}
      standalone
      companyId={state.companyId}
      companyName={state.companyName}
      target={state.target}
      onSaved={onSaved}
    />
  );
}

export default MemoWindow;
